import React, { useEffect, useState } from "react";
import Head from "next/head";
import striptags from "striptags";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";

const Loader = dynamic(() => import("../../components/common/Loader/Loader"));
const Layout = dynamic(() => import("../../components/common/Layout/Layout"));
const Service = dynamic(() => import("../../components/Service/Service"));

const service = ({ apiData }) => {
  const [loader, setLoader] = useState(true);

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const search_description = apiData?.meta?.search_description;
  const canonicalUrl = apiData?.canonical_url;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;

  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  useEffect(() => {
    if (footerData) {
      setLoader(false);
    }
  }, []);

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />

        <link rel="canonical" href={canonicalUrl} />

        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />

        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}

      </Head>
      <Layout
        webLogo={
          footerData &&
          footerData?.site_configuration &&
          footerData?.site_configuration[0]?.logo?.url
        }
      >
        {loader && <Loader />}
        <Service data={apiData?.detail_page} />
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  // Fetch data from your API
  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/services",
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  if (apiData?.redirect_url) {
    return {
      redirect: {
        destination: apiData.redirect_url,
        permanent: false,
      },
    };
  }

  return {
    props: {
      apiData,
    },
  };
}

export default service;
